export const CONSTANTS = {
  SCREEN_GROUP: 'item',
  LIST_ALL: 'list-item-all',
  LIST_ITEM_CUSTOMER_PRODUCT_GROUP: 'list-item-customer-product-group',
  LIST_ITEM_CUSTOMER_RATE_GROUP: 'list-item-customer-rate-group',
  GRID_ITEM_LOOKUP_DIALOG: 'grid-item-lookup-dialog',
  ITEM_LOT_REQUIRED_CHECK: 'item-lot-required-check',
} as const;
